/**
 * ? @description : Delete Entire Batch
 */

// Dependencies
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";

function MappedModalDelete(props) {
  // * Redux Variables
  const dispatch = useDispatch();

  // * Store the Id of the Selected Row Data
  const id = props.datatodeletebatchmodal;

  // ? API Call : Delete Method : Entire Batch
  const deleteBatch = async () => {
    try {
      const options = {
        method: "delete",
        url: `/batches/${id}`,
        auth: true,
        data: null,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 200) {
        props.onHide();
        window.location.reload();
        dispatch(
          showSnackbar({
            message: "Batch has been deleted successfully !",
            severity: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message:
            "Error occurred! Unable to delete data. Please try again later.",
          severity: "error",
        })
      );
    }
  };

  return (
    props.datatodeletebatchmodal && (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <p>
            Note&nbsp;:&nbsp;
            <strong style={{ color: "red" }}>
              If you delete the entire Group before
              unmapping&nbsp;&amp;&nbsp;ungrouping the profiles, then the Group
              Status, Mapped Status, Group Id&nbsp;&amp;&nbsp;Group Name of Both
              Teachers and Students Data will be deleted and Reset to
              Ungroup&nbsp;&amp;&nbsp;Unmapped.
            </strong>
          </p>

          <br />

          <h4>Are you sure to delete the entire Group ?</h4>
        </Modal.Body>

        <Modal.Footer>
          <Button type="button" variant="light" onClick={props.onHide}>
            CANCEL
          </Button>
          <Button type="submit" variant="danger" onClick={deleteBatch}>
            DELETE
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default MappedModalDelete;
